import { combineReducers } from 'redux'

import emailSettings from './email_settings'

export default combineReducers({
  emailSettings
})
